import React, { FC } from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { Button, ButtonColor, ButtonSize } from '@code/innovance-react-ui-kit';

export const ButtonRow = styled.div`
  display: flex;
  justify-content: flex-end;
`;

const Overlay = styled.div<{ zIndex?: number }>`
  position: fixed;
  z-index: ${({ zIndex }) => zIndex || 999};
  top: 0;
  left: 0;

  width: 100%;
  height: 100%;

  background: ${({ theme }) => theme.palette.dark50};
`;

const ModalContainer = styled.div<{ size?: string }>`
  position: absolute;
  top: 50%;
  left: 50%;

  display: flex;
  max-height: 85vh;
  min-height: ${({ size }) => size};

  padding: 10px 24px 24px;
  border: 1px solid ${({ theme }) => theme.palette.paleGreyTwo};
  border-radius: 6px;

  background-color: ${({ theme }) => theme.palette.white};
  overflow-y: auto;
  flex-direction: column;
  box-shadow: 0 12px 24px 0px ${({ theme }) => theme.palette.dark15};
  transform: translate(-50%, -50%);
`;

const CloseButton = styled(Button)`
  border: none;
`;

interface Props {
  onClose: () => void;
  zIndex?: number;
  size?: string;
}

const FormModal: FC<Props> = ({ onClose, children, zIndex, size }) => {
  const { t } = useTranslation();

  return (
    <Overlay zIndex={zIndex}>
      <ModalContainer role="dialog" size={size}>
        <ButtonRow>
          <CloseButton
            color={ButtonColor.Secondary}
            onClick={onClose}
            size={ButtonSize.Small}
            text={t('general_components_close_button')}
          />
        </ButtonRow>
        {children}
      </ModalContainer>
    </Overlay>
  );
};
export default FormModal;
